module.exports = __webpack_public_path__ + "img/1-2.18cb337a.jpg";